module.exports = __webpack_public_path__ + "static/media/4.846479ed.png";